export default function ArrowUp() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2322 9.06065L4.64645 14.6464L5.35355 15.3535L10.9393 9.76776C11.5251 9.18197 12.4749 9.18197 13.0607 9.76776L18.6464 15.3535L19.3536 14.6464L13.7678 9.06065C12.7915 8.08434 11.2085 8.08434 10.2322 9.06065Z"
          fill="white"
        />
      </svg>
    </>
  );
}
